import { Subject } from 'rxjs';
export function createEventHandler() {
    const events$ = new Subject();
    return [events$.asObservable(), (event) => events$.next(event)];
}
